import config from "appConfig";

const walls = {
  "1-2-3-4-5-6": {
    imageUrl: `${config.ASSETS_URL}/01/18/principle/walls/1-2-3-4-5-6.svg`,
    equationImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-1-2-3-4-5-6.svg`,
    equationSmallImageUrl: `${config.ASSETS_URL}/01/18/principle/equations/eq-sub-9.svg`,
  },
};

export default walls;
